<template>
    <!-- <AdminLayout> -->
        <section class="flex items-start">
            <div class="w-full">
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between mb-5">
                            <p class="font-semibold text-xl text-neutral-800">Leave Report</p>
                        </div>

                        <div class="flex mb-8 items-center bg-neutral-300/50 rounded-md p-1">
                            <div class="ml-auto" v-if="userType === 'admin'">
                                <label class="text-sm leading-none font-normal text-black mr-2">Filter:</label>
                                <select class="border border-white text-sm rounded-full py-1 px-2"
                                    v-model="slectedLocation" @change="fetchLeaveRequests">
                                    <option value="">Location</option>
                                    <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{
                                        branch.name }}</option>
                                </select>
                            </div>
                            <div class="w-96 mx-3">
                                <input type="search" v-model="searchQuery" name="" id=""
                                    class="w-full rounded-full bg-white text-sm px-6 py-3 outline-none block font-normal"
                                    placeholder="Search...">
                            </div>
                            <!-- <div>
                                <button class="btn-primary">
                                    Download
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="ml-2"><path fill="currentColor" d="M12 4v12.25L17.25 11l.75.66l-6.5 6.5l-6.5-6.5l.75-.66L11 16.25V4zM3 19h1v2h15v-2h1v3H3z"/></svg>
                                </button>
                            </div> -->
                        </div>
                        <!-- <div class="mb-2">
                            <p class="font-medium text-sm text-black ">Number of leaves taken: <span class="text-neutral-700 font-normal">0</span> </p>
                        </div> -->

                        <div>
                            <div class="grid grid-cols-7 bg-[#ECF6FF] divide-x divide-[#eaeaea]">
                                <div
                                    class="text-sm leading-none px-2 text-[#404A5A] py-3 flex items-center font-normal justify-center">
                                    No.</div>
                                <div class="text-sm leading-none px-2 text-[#404A5A] py-3 flex items-center font-normal col-span-2">
                                    Employee Name</div>
                                <div class="text-sm leading-none px-2 text-[#404A5A] py-3 flex items-center font-normal">Employee ID
                                </div>
                                <div class="text-sm leading-none px-2 text-[#404A5A] py-3 flex items-center font-normal">Leaves Details
                                </div>

                                <!-- <div class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">Actions</div> -->
                            </div>

                            <div v-if="isLoading">
                                <div v-if="isLoading">
                                    <div class="grid grid-cols-7 bg-white divide-x-[1px] shadow mt-1.5 animate-pulse" v-for="index in 10" :key="index">
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2 col-span-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                        <div class="px-2 py-2 col-span-3">
                                            <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Actual Data -->
                            <div v-else>
                                <div v-if="paginatedData.length === 0" class="text-center py-6 text-neutral-500 text-sm">
                                  No data found.
                                </div>
                                <div v-for="(employee, index) in paginatedData" :key="index">
                                    <div
                                        class="grid grid-cols-7 bg-white divide-x divide-y divide-[#eaeaea]">
                                        <div
                                            class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center border-t border-[#eaeaea]">
                                            {{startIndex + index + 1 }}
                                        </div>
                                        <div
                                            class="text-sm leading-none px-2 py-3 flex items-center font-normal col-span-2">
                                            {{ employee.fname }} {{ employee.lname }}
                                        </div>
                                        <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">
                                            {{ employee.empid }}
                                        </div>

                                        <div class="text-sm leading-none px-2 py-3 flex items-center font-normal col-span-3">
                                            <table class="glob_table w-full">
                                                <thead class="bg-[#ECF6FF]">
                                                    <tr>
                                                        <th class="text-[11px] leading-none p-2 font-semibold">Name</th>
                                                        <th class="text-[11px] leading-none p-2 font-semibold">Total
                                                            Leave</th>
                                                        <th class="text-[11px] leading-none p-2 font-semibold">Leave
                                                            Left</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-if="employee.leaves.length > 0">
                                                    <tr v-for="(leave, index) in employee.leaves" :key="index">
                                                        <td class="px-2 py-2 text-xs font-normal">
                                                            {{ leave.leave_name }}
                                                        </td>
                                                        <td class="px-2 py-2 text-xs font-normal">{{ leave.total_leave
                                                            }}</td>
                                                        <td class="px-2 py-2 text-xs font-normal">{{ leave.leave_left }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <div v-else class="p-2 text-sm">
                                                    No leaves taken
                                                </div>
                                            </table>
                                        </div>
                                        <!-- <div class="text-sm leading-none px-2 py-3 flex items-center font-normal justify-center">
                                                <a href="#" class="inline-flex items-center justify-center bg-blue-400 rounded-md px-3 py-2 text-white text-xs font-normal">View Record</a>
                                            </div> -->
                                    </div>
                                </div>
                                <PaginationComponent :totalItems="total" :itemsPerPage="itemsPerPage"
                                    v-model:currentPage="currentPage" />
                            </div>


                        </div>


                    </div>
                </div>
            </div>
            <!-- <RightSideBar /> -->
        </section>
    <!-- </AdminLayout> -->
</template>

<script>
// import AdminLayout from '../AdminDashboard/AdminLayout.vue';
// import RightSideBar from '../../components/RightSideBar.vue';
import PaginationComponent from "../../components/PaginationComponent.vue";
import axios from 'axios';
import { BASE_URL } from "../../config";
import debounce from 'lodash/debounce'; // ← Add this at the top
import { createLocal } from 'the-storages';

const mirror = createLocal();
const storage = mirror._prx;
export default {
    name: 'LeaveListing',
    components: {
        // AdminLayout,
        // RightSideBar,
        PaginationComponent
    },
    data() {
        return {
            data: [],
            itemsPerPage: 10,
            currentPage: 1,
            total: 0, // Declare total items
            searchQuery: null, // ← ADD THIS
            storage: storage,
            branchList: [],
            slectedLocation: '',
            userType: '',
            isLoading: true,
            previousLocation: '', // Add this to track location changes
        };
    },
    computed: {
        paginatedData() {
            //const start = (this.currentPage - 1) * this.itemsPerPage;
            //return this.data.slice(start, start + this.itemsPerPage);
            return this.data;
        },
        startIndex() {
            return (this.currentPage - 1) * this.itemsPerPage;
        }
    },
    watch: {
        searchQuery() {
            this.onSearch();
        },
        currentPage(newPage) {
            this.$router.push({ query: { ...this.$route.query, page: newPage } }); // ← add this
            this.fetchLeaveRequests(); // Fetch data when page changes
        }
    },
    methods: {
        // async fetchLeaveRequests() {
        // try {
        // const response = await axios.get(
        //     `${BASE_URL}/employees-leave-records?limit=${this.itemsPerPage}&page=${this.currentPage}`
        // );
        // //console.log(response.data.data,"kkkk")
        // this.data = response.data.data; // Corrected
        // this.total = response.data.total; // Corrected
        // } catch (error) {
        //         console.error("Error fetching leave requests:", error);
        //     }
        // }

        async fetchLeaveRequests() {
            this.isLoading = true;
            try {
                // Only reset page if location changed (not just when it has a value)
                if (this.slectedLocation !== this.previousLocation) {
                    this.currentPage = 1;
                    this.previousLocation = this.slectedLocation;
                }
                const response = await axios.get(
                    `${BASE_URL}/employees-leave-records`, {
                    params: {
                        limit: this.itemsPerPage,
                        page: this.currentPage,
                        name: this.searchQuery, // ← Send search query
                        location: this.slectedLocation,
                    }
                }
                );
                this.data = response.data.data;
                this.total = response.data.total;
            } catch (error) {
                console.error("Error fetching leave requests:", error);
            } finally {
                this.isLoading = false;
            }
        },

        async getBranchList() {
            const formData = {
                "company_id": this.storage.companyDetails.id
            };
            await axios.post(BASE_URL + '/get-emp-branch-list', formData)
                .then((response) => {
                    this.branchList = response.data.branchDetails;
                    console.log("Role LIST:: ", response.data);
                })
        },

    },
    mounted() {
        this.fetchLeaveRequests(); // Fetch data when component mounts
    },
    // onSearch() {
    //     this.currentPage = 1; // Reset to first page when searching
    //     this.fetchLeaveRequests();
    // },
    created() {
        const page = parseInt(this.$route.query.page) || 1;
        this.currentPage = page;
        if (this.storage.userType === 'Super Admin') {
            this.slectedLocation = ''; // Set to an empty string or a default value
            this.userType = 'admin';
        } else {
            this.slectedLocation = this.storage.employeeDetails.branch; // Assign only if branch is valid
            this.userType = 'not-admin';
            console.log('branch', this.slectedLocation);
        }
        this.getBranchList();

        this.onSearch = debounce(() => {
            this.currentPage = 1;
            this.fetchLeaveRequests();
        }, 400);
    },
};
</script>
